export class SummaryDepositModel {
    public TotalStatusAll!: number;
    public TotalStatus1!: number;
    public TotalStatus7!: number;
    public TotalStatus8!: number;
    public TotalStatus9!: number;
    public TotalStatus10!: number;
    public TotalStatus16!: number;
}